(function(w, d) {
	const messengers = d.querySelector('.js-messengers');
	const messengersList = d.querySelector('.js-messengers-list');
	const messengersGreeting = d.querySelector('.js-messengers-greeting');
	const button = d.querySelector('.js-messengers-button');
	const throttleTime = 200;

	if (button) {
		d.addEventListener('click', e => {
			const targetElement = e.target;
			const isOpen = JSON.parse(button.dataset.messengersOpen);

			if (targetElement === button || isOpen) {
				button.dataset.messengersOpen = !isOpen;
				messengersList.classList.toggle('messengers__list_active');
				messengersGreeting.classList.toggle('messengers__greeting_active');
			}
		})
		w.addEventListener('scroll', throttle(setBottomOffset, throttleTime));

		function setBottomOffset() {
			const bottomOffset = w.calcBottomOffset(20);
			messengers.style.bottom = `${bottomOffset}px`;
		}
	}
})(window, document);
